import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import type {
  IAnalyticsParams,
  IAnalyticsPreloadResponse,
  IAnalyticsExportParams,
  IAnalyticsExportResponse,
  StatisticBase,
  ChartBase,
  AnalyticsResponse,
} from './types'

export class BaseAnalyticsApi<TStatistic extends StatisticBase, TChart extends ChartBase> {
  constructor(private _segment: string) {}

  preloadAnalytics = (
    params: IAnalyticsParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IAnalyticsPreloadResponse>> => {
    return baseApi.get(`analytics/analytics/${this._segment}`, {
      params: {
        ...params,
        preload_type: 'previous',
      },
      ...options,
    })
  }

  getAnalytics = (
    params: IAnalyticsParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<AnalyticsResponse<TStatistic, TChart>>> => {
    return baseApi.get(`analytics/analytics/${this._segment}`, {
      params,
      ...options,
    })
  }

  exportAnalytics = (
    params: IAnalyticsExportParams,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IAnalyticsExportResponse>> => {
    return baseApi.get(`core/analytics/${this._segment}/export`, {
      params,
      ...options,
    })
  }
}
